/**
 * cart-terms-validation.js
 * Stabilna walidacja checkboxa Regulaminu Sklepu przez event delegation na document.
 * Ładowany globalnie z layout/theme.liquid — działa niezależnie od przeładowań AJAX.
 */

(function () {
  if (window.__cartTermsValidationLoaded) return;
  window.__cartTermsValidationLoaded = true;

  function getCheckbox() {
    return document.getElementById('cart-terms-consent-checkbox');
  }

  function getError() {
    return document.getElementById('cart-terms-consent-error');
  }

  function showError() {
    var error = getError();
    var checkbox = getCheckbox();
    if (error) error.style.display = 'block';
    if (checkbox) checkbox.focus();
  }

  function hideError() {
    var error = getError();
    if (error) error.style.display = 'none';
  }

  function validateTerms() {
    var checkbox = getCheckbox();
    if (!checkbox) return true;
    return checkbox.checked;
  }

  // Przechwytuje kliknięcie przycisku checkout (capture: true = przed innymi listenerami)
  document.addEventListener('click', function (e) {
    var target = e.target;
    var checkoutBtn =
      target.id === 'checkout'
        ? target
        : target.closest('#checkout, [name="checkout"]');

    if (checkoutBtn) {
      if (!validateTerms()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
        return false;
      }
    }

    // Ukryj błąd po zaznaczeniu checkboxa
    if (target.id === 'cart-terms-consent-checkbox' && target.checked) {
      hideError();
    }
  }, true);

  // Fallback: submit formularza cart-form
  document.addEventListener('submit', function (e) {
    if (e.target.id !== 'cart-form') return;
    if (!validateTerms()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
      return false;
    }
  }, true);

})();


